export const LOADING_PLAN = "LOADING_PLAN";
export const SAVE_LOADING_PLAN = "SAVE_LOADING_PLAN";
export const GET_PLAN = "GET_PLAN";
export const FORM_PLAN_FAIL = "FORM_PLAN_FAIL";
export const PLAN_FAIL = "PLAN_FAIL";
export const LOADING_PLAN_BY_ID = "LOADING_PLAN_BY_ID";
export const GET_PLAN_BY_ID = "GET_PLAN_BY_ID";